"use strict";
/**
 * @license
 * Copyright 2017 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var leftPad_1 = require("./leftPad");
function formatLogTimestamp(date) {
    var pad = function (val, length) { return leftPad_1.leftPad(String(val), "0", length); };
    return ("" + pad(date.getHours(), 2) +
        (":" + pad(date.getMinutes(), 2)) +
        (":" + pad(date.getSeconds(), 2)) +
        ("." + pad(date.getMilliseconds(), 3)));
}
exports.formatLogTimestamp = formatLogTimestamp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redoodle/lib/internal/utils/formatLogTimestamp.js
// module id = 259
// module chunks = 0